import type { BaseChartData } from '@/api/chart/chart.service'
import { GetChartResponseType, SelectedTanksType } from '../../types/apiResponse/chartTypes'

/**
 * @deprecated Use makeCSVFormV2 instead
 */
export const makeCSVForm = (
  chartQueryResult: GetChartResponseType,
  selectedTanks: SelectedTanksType,
) => {
  const resultArray: object[] = []
  if (!chartQueryResult || typeof chartQueryResult !== 'object') {
    return resultArray
  }
  Object.entries(chartQueryResult).forEach((propertyEntry) => {
    const property = propertyEntry[0]
    const propertyValue = propertyEntry[1]?.value
    if (!propertyValue || typeof propertyValue !== 'object') return
    Object.entries(propertyValue).forEach((schoolEntry) => {
      const schoolId = schoolEntry[0]
      const values = schoolEntry[1]
      if (!Array.isArray(values)) return
      const filteredSelectedTanks = selectedTanks.filter((val) => val.schoolId === schoolId)
      if (filteredSelectedTanks.length === 0) return
      const tankName = filteredSelectedTanks[0].tankName

      values.forEach(({ x, y }) =>
        resultArray.push({
          property: property,
          value: y,
          date: x,
          tank: tankName,
        }),
      )
    })
  })
  return resultArray
}

/**
 * Create CSV data from new chart API response (V2)
 */
export const makeCSVFormV2 = (
  chartData: BaseChartData,
  property: string,
  selectedTanks: SelectedTanksType,
) => {
  const resultArray: object[] = []
  if (!chartData || typeof chartData !== 'object') {
    return resultArray
  }

  Object.entries(chartData.xyPointsPerSchoolId).forEach((schoolEntry) => {
    const schoolId = schoolEntry[0]
    const values = schoolEntry[1]
    if (!Array.isArray(values)) return
    const filteredSelectedTanks = selectedTanks.filter((val) => val.schoolId === schoolId)
    if (filteredSelectedTanks.length === 0) return
    const tankName = filteredSelectedTanks[0].tankName

    values.forEach(({ x, y }) =>
      resultArray.push({
        property: property,
        value: y,
        date: x,
        tank: tankName,
      }),
    )
  })
  return resultArray
}
